module.exports = __webpack_public_path__ + "static/media/IMG_4008.79ff8333.jpg";